// Module
var code = "<h1 class=\"heading--isInteriorPageSubHeadingLeft\"> Loan Discharge</h1> <p>Your federal student loan debt may qualify for loan discharge if the loan was issued under certain conditions. The following loan discharges are available for AES serviced student loans:</p> ";
// Exports
export default code;